export default "__VITE_ASSET__BMdbZQoT__"